// A cell reads as blank in the plays grid when it is null, undefined, an empty
// string, or the "-" placeholder some valueGetters return for a missing value.
export const isBlankCell = (v) => v == null || v === '' || v === '-';

const compareValues = (a, b) => {
  if (typeof a === 'string' && typeof b === 'string') {
    return a.localeCompare(b, undefined, { numeric: true });
  }
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
};

// AG Grid column comparator that keeps blank cells at the bottom in both sort
// directions. AG Grid's default treats null as the lowest value, so blanks
// lead on an ascending sort - which for a tri-state like MOFO (Yes / No / not
// evaluated) buries the real values under the unevaluated plays. The previous
// plays table pushed missing values last whichever way you sorted; this keeps
// that behaviour.
//
// AG Grid negates the comparator's result for a descending sort, so the blank
// branches return the opposite sign when `isDescending` is true to land in the
// same place.
export const nullsLastComparator = (a, b, _nodeA, _nodeB, isDescending) => {
  const aBlank = isBlankCell(a);
  const bBlank = isBlankCell(b);
  if (aBlank && bBlank) return 0;
  if (aBlank) return isDescending ? -1 : 1;
  if (bBlank) return isDescending ? 1 : -1;
  return compareValues(a, b);
};
